import { useEffect } from 'react';
import { useAddress } from '../contexts/AddressContext';
import { getStayInfo } from '../api/stayService';
import { loadPendingStayId, removePendingStayId } from '../utils/pendingStayUtils';

/**
 * 온보딩 중 백그라운드에서 Stay 정보를 미리 로드하는 Hook
 * UI/UX에 영향 없이 주소 정보만 설정
 * 온보딩 중이 아닌 경우에는 GlobalUrlParameterHandler에서 처리하므로 실행하지 않음
 */
export const useStayPreloader = () => {
  const { address, setAddress } = useAddress();

  useEffect(() => {
    const loadPendingStay = async () => {
      // 온보딩 상태 확인 - 온보딩이 완료된 경우에는 실행하지 않음
      const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding');
      if (hasSeenOnboarding) {
        // 온보딩이 완료된 경우 GlobalUrlParameterHandler에서 처리하므로 여기서는 실행하지 않음
        return;
      }

      const pendingStayId = loadPendingStayId();
      
      // Stay ID가 있고, 현재 설정된 stay와 다른 경우에만 처리
      // (동일 stayId가 이미 로드되었으면 스킵, 다른 호텔이면 새로 로드)
      const currentStayId = address?.stay?.stay_id ?? address?.stay?.id;
      if (pendingStayId && pendingStayId !== currentStayId) {
        try {
          console.log('🏨 Stay 정보 백그라운드 로드 시작 (온보딩 중):', pendingStayId);
          
          const stayInfo = await getStayInfo(pendingStayId);

          if (stayInfo.active === false) {
            removePendingStayId();
            return;
          }
          
          // 주소 정보를 설정 (기존 주소가 있으면 덮어쓰기)
          setAddress({
            mainAddress: stayInfo.address.address,
            detailAddress: stayInfo.address.detail_address,
            isComplete: true,
            lat: stayInfo.address.lat,
            lng: stayInfo.address.lng,
            addressId: stayInfo.address.id,
            stay: stayInfo
          });

          // 성공 시 pendingStayId 제거 (중복 처리 방지)
          removePendingStayId();
          
          console.log('✅ Stay 정보 설정 완료 (온보딩 중):', stayInfo.address.address);
        } catch (error) {
          console.error('❌ Stay 정보 로드 실패 (온보딩 중):', error);
          // 에러 발생 시에도 pendingStayId는 유지 (나중에 재시도 가능)
        }
      }
    };

    loadPendingStay();
  }, [setAddress, address?.stay]); // address.stay 변경 시에만 재실행
}; 